import { useAuth } from "./AuthProvider";
import { Navigate } from "react-router-dom";

const AuthRoute = ({ children, admin }) => {
    const { token, loading, user } = useAuth();

    // If the user is not authenticated, redirect to the login page
    if (loading) {
        return null;
    }

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (admin && !user?.admin) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default AuthRoute;